import { AlertTriangle, X } from "lucide-react";
import { LGoButton } from "@/ui/branded";

interface CaptureIncidentBannerProps {
  reservationId: number;
  onDismiss: () => void;
}

/** Money moved and no row records it. Stays on screen — no auto-dismiss, no
 *  swipe-away toast — until the partner deliberately closes it, and it names
 *  the reservation so the sentence still means something when read out over
 *  the phone to support. */
export function CaptureIncidentBanner({ reservationId, onDismiss }: CaptureIncidentBannerProps) {
  return (
    <div
      role="alert"
      className="flex items-start gap-3 rounded-xl border border-destructive/50 bg-destructive/10 p-4"
    >
      <AlertTriangle className="h-5 w-5 shrink-0 text-destructive" aria-hidden="true" />
      <div className="flex-1 space-y-1">
        <p className="font-medium text-destructive">Platba proběhla, záznam chybí</p>
        <p className="text-sm text-destructive">
          {`Platba za rezervaci č. ${reservationId} proběhla, ale nepodařilo se ji zaznamenat. Znovu ji nepotvrzujte — záznam doplňujeme ručně.`}
        </p>
      </div>
      <LGoButton
        variant="ghost"
        size="sm"
        iconLeft={<X />}
        onClick={onDismiss}
        aria-label="Zavřít upozornění o nezaznamenané platbě"
      >
        Zavřít
      </LGoButton>
    </div>
  );
}
